import { render, staticRenderFns } from "./TaxSubmission.vue?vue&type=template&id=0acabf5a&scoped=true"
import script from "./TaxSubmission.vue?vue&type=script&lang=js"
export * from "./TaxSubmission.vue?vue&type=script&lang=js"
import style0 from "./TaxSubmission.vue?vue&type=style&index=0&id=0acabf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acabf5a",
  null
  
)

export default component.exports